module.exports = __webpack_public_path__ + "static/media/gallery07.c1131339.jpeg";